<script setup lang="ts">
import { TableColumn } from '@/components/Table'
import ActionsColumnComponent from './components/ActionsColumnComponent.vue'
</script>

<template>
    <TableColumn :label="$t('common.actions')" width="50px" v-slot="props">
        <ActionsColumnComponent v-bind="{ ...$attrs, ...props }">
            <template #before><slot name="before" v-bind="props.row" /></template>
            <template #after><slot name="after" v-bind="props.row" /></template>
        </ActionsColumnComponent>
    </TableColumn>
</template>
